import axios from "axios";

const request = axios.create({
   url: '/ajax/',
   baseURL: '/api/rooms/',
   headers: {'X-Requested-With': 'XMLHttpRequest'},
})

const complexId = document.querySelector( 'section.chooser.param' )?.getAttribute( 'data-complex-id' );

export const getApartmentsRequest = () => {
    return request.post(`?complex=${complexId}`,)
        .then(response => {
            return response.data;
        })
}

export const getFilterApartmentsRequest = ({ type, buildings, price, area, sort }) => {
    const params = [
		`complex=${complexId}`,
        type ? `type=${type}` : '',
        buildings ? `section=${buildings.join(',')}` : '',
        (price.min || price.max) ? `price=${price.min}-${price.max}` : '',
        (area.min || area.max) ? `area=${area.min}-${area.max + 1}` : '',
        `sort=${sort}`
    ].filter(Boolean).join('&');

    return request.post(`?${params}`)
        .then((response) => {
            return response.data;
        });
};
